<template>
  <div class="ryxx_box">
    <Tabs class="sh_box" style="margin-top: 10px" value="name1">
      <Tab-pane label="申报记录" name="name1">
        <div class="search_box">
          <div>
            <div>
              审核状态：
              <el-select
                v-model="formSh.status"
                placeholder="请选择审核状态"
                style="width: 180px; height: 25px"
              >
                <el-option
                  v-for="(item, index) in shList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="btn1" @click="toSearchSh">查询</div>
            <div class="btn2" @click="toResetSh">重置</div>
            <div>
              <div class="btn1" @click="addPersonnel">项目负责人申报</div>
            </div>
          </div>
        </div>
        <div>
          <el-table
            v-loading="loading"
            :cell-style="{ padding: '10px' }"
            :data="ryShList"
            :header-cell-style="{
              lineHeight: '42px',
              height: '42px',
              padding: 0,
              backgroundColor: '#49b3ff',
              color: '#515a6e',
            }"
            stripe
            style="width: 100%"
          >
            <el-table-column
              align="center"
              label="序号"
              type="index"
              width="80px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              label="姓名"
              prop="stuName"
              show-overflow-tooltip
              width="120px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              label="手机号"
              prop="phone"
              show-overflow-tooltip
              width="150px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              label="身份证号码"
              prop="idcard"
              show-overflow-tooltip
              width="150px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              label="审核名称"
              prop="templateName"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              align="center"
              label="审核批次"
              prop="sbpc"
              show-overflow-tooltip
              width="150"
            >
            </el-table-column>
            <el-table-column
              align="center"
              label="申报状态"
              prop="status"
              show-overflow-tooltip
              width="100"
            >
              <template slot-scope="scope">
                {{
                  (scope.row.status &&
                    scope.row.status !== null &&
                    scope.row.status !== undefined) ||
                  scope.row.status == 0
                    ? shList.find((item) => item.value == scope.row.status)
                        .label
                    : "-"
                }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="缴费状态"
              prop="payment"
              show-overflow-tooltip
              width="100"
            >
              <template slot-scope="scope">
                {{
                  scope.row.payment
                    ? paymentList.find(
                        (item) => item.value == scope.row.payment,
                      ).label
                    : ""
                }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="审核结果"
              prop="result"
              show-overflow-tooltip
              width="100"
            >
              <template slot-scope="scope">
                {{
                  scope.row.result == "1"
                    ? "通过"
                    : scope.row.result == "0"
                      ? "不通过"
                      : ""
                }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="填报日期"
              prop="createTime"
              show-overflow-tooltip
              width="180"
            ></el-table-column>
            <el-table-column align="center" label="操作" width="240">
              <template #default="scope">
                <el-button
                  style="margin-right: 5px"
                  type="text"
                  @click="goShDetail(scope.row, 'look')"
                  >查看详情
                </el-button>
                <el-button
                  v-if="
                    scope.row.status == '0' ||
                    scope.row.status == '1' ||
                    scope.row.status == '-1'
                  "
                  style="margin-right: 5px"
                  type="text"
                  @click="goShDetail(scope.row, 'edit')"
                  >资料上传
                </el-button>
                <el-popconfirm
                  v-if="scope.row.status == '0'"
                  title="确定要删除该数据吗？"
                  @confirm="rowDelete(scope.row)"
                >
                  <el-button
                    slot="reference"
                    style="margin-left: 10px"
                    type="text"
                    >删除
                  </el-button>
                </el-popconfirm>
                <el-button
                  v-if="scope.row.status != '0'"
                  style="margin-right: 5px"
                  type="text"
                  @click="reviewProgressClick(scope.row)"
                >
                  评审进度
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <Page
          v-if="ryShList.length !== 0"
          :current="paramsSh.pageNo"
          :page-size="paramsSh.pageSize"
          :total="totalSh"
          class="common_page_box"
          show-total
          @on-change="changePageSh"
        ></Page>
      </Tab-pane>
    </Tabs>
    <vipLogin ref="vipbox"></vipLogin>

    <AddPersonnel ref="AddPersonnelRef" @success="toResetSh"></AddPersonnel>
    <UploadAttachment
      ref="UploadAttachmentRef"
      :details="details"
      @handleClose="toResetSh"
      @success="toResetSh"
    ></UploadAttachment>
    <ReviewProgress
      :details="ReviewProgressDetails"
      @handleClose="handleClose"
    ></ReviewProgress>
    <div v-if="showXx">
      <el-button @click="backXx">返回</el-button>
    </div>
  </div>
</template>

<script>
import vipLogin from "@/components/vip_login.vue";
import UploadAttachment from "./uploadAttachment.vue";

import {
  deleteDeclareAndDetailCyryApi,
  getDeclareRecordByUserApi,
  getXmfzr,
} from "@/api/home/index";
import AddPersonnel from "./addPersonnel.vue";
import ReviewProgress from "./ReviewProgress.vue";

export default {
  name: "xmfzr",
  components: {
    ReviewProgress,
    AddPersonnel,
    vipLogin,
    UploadAttachment,
  },
  data() {
    return {
      th: [
        "#",
        "序号",
        "姓名",
        "优秀人员",
        "身份证号",
        "从业单位",
        "证书编号",
        "有效期限",
        "查看",
      ],
      total: 0,
      params: {
        pageNo: 1,
        pageSize: 10,
      },
      form: {
        certName: "",
        certNo: "",
        certCompany: "",
      },
      ryList: [],
      xh_userInfo: {
        user: {
          username: "",
        },
      },
      showAlert: false,
      showAlertAddExcellence: false,
      showXx: false,
      studentId: "",
      // 人员申请信息
      ryShList: [],
      totalSh: 0,
      paramsSh: {
        pageNo: 1,
        pageSize: 10,
      },
      formSh: {
        name: "",
        status: "",
      },
      shList: [
        { label: "待缴费", value: "0" },
        { label: "待提交", value: "1" },
        { label: "待评审", value: "2" },
        { label: "评审完成", value: "3" },
        { label: "公示完成", value: "4" },
        { label: "已退回", value: "-1" },
        { label: "违规取消", value: "-2" },
      ],
      paymentList: [
        { label: "待支付", value: "0" },
        { label: "已支付", value: "1" },
      ],
      details: {
        dialogVisible: false,
        title: "项目负责人申报",
        type: "edit",
        data: {},
      },
      ReviewProgressDetails: {
        dialogVisible: false,
        title: "评审进度",
        data: {},
      },
      loading: false,
    };
  },
  mounted() {
    if (this.$Cookies.get("xh_userInfo")) {
      this.xh_userInfo = JSON.parse(this.$Cookies.get("xh_userInfo"));
    }
    // this.getCyry();
    this.getCyrySh();
  },
  methods: {
    changePage(e) {
      this.params.pageNo = e;
      // this.getCyry();
    },
    getCyry() {
      getXmfzr({
        ...this.params,
        ...this.form,
        certCompany: this.xh_userInfo.user.dwmc,
      }).then((res) => {
        if (res.code == 200 || res.code == 0) {
          let info = res.result.records;
          this.ryList = info;
          this.total = res.result.total;
        } else if (res.code == 401) {
          this.$refs["vipbox"].showLogin = true;
        }
      });
    },
    toSearch() {
      this.params.pageNo = 1;
      this.getCyry();
    },
    toReset() {
      this.form = {};
      this.params.pageNo = 1;
      this.getCyry();
    },
    toLogoff() {
      let names = [];
      let stuids = [];
      this.ryList.forEach((item) => {
        console.log("========item======", item);
        if (item.isCheck) {
          names.push(item.name);
          stuids.push(item.stuUUID);
        }
      });
      if (stuids.length == 0) {
        this.showAlert = true;
        return false;
      }

      let formData = { names: names.join(","), stuids: stuids.join(",") };
      this.$refs["logoffModal"].showPop = true;
      this.$refs["logoffModal"].formData = JSON.stringify(formData);
    },
    addExcellence() {
      let names = [];
      let reviewRecords = [];
      this.ryList.forEach((item) => {
        console.log("========item======", item);
        if (item.isCheck) {
          names.push(item.certName);
          reviewRecords.push(item.id);
        }
      });
      if (reviewRecords.length == 0) {
        this.showAlertAddExcellence = true;
        return false;
      }

      let formData = { names: names.join(","), reviewRecords: reviewRecords };
      this.$refs["AddExcellence"].showPop = true;
      this.$refs["AddExcellence"].formData = JSON.stringify(formData);
    },
    goDetail(it) {
      this.$refs["detailModal"].showPop = true;
      this.$refs["detailModal"].certno = it.certNo;
    },
    goStudy(it) {
      this.showXx = true;
      this.studentId = it.stuUUID;
      console.log("tokens", this.tokens);
      // this.$router.push({name: 'cyry', params: {studentId: it.stuUUID, token: tokens}})
    },
    backXx() {
      this.showXx = false;
    },
    /* 人员申请信息 start*/
    goShDetail(row, type) {
      // 修改审核不通过数据
      // this.$refs.UploadAttachmentRef.dialogVisible = true;
      // this.$refs.UploadAttachmentRef.setData(row);
      console.log(row, "goShDetail");
      if (row.payment == "0" && type == "edit") {
        this.$message.info("申请已提交，请尽快缴纳费用。");
        return;
      }
      this.details.dialogVisible = true;
      this.details.data = row;
      this.details.type = type;
    },
    changePageSh(e) {
      this.paramsSh.pageNo = e;
      this.getCyrySh();
    },
    toSearchSh() {
      this.paramsSh.pageNo = 1;
      this.getCyrySh();
    },
    toResetSh() {
      this.formSh = {};
      this.paramsSh.pageNo = 1;
      this.details.dialogVisible = false;
      this.getCyrySh();
    },
    getCyrySh() {
      console.log("this.formsh", this.formSh);
      this.loading = true;
      getDeclareRecordByUserApi({
        ...this.paramsSh,
        ...this.formSh,
      })
        .then((res) => {
          if (res.code == 200 || res.code == 0) {
            let info = res.result.records || [];
            this.ryShList = info;
            this.totalSh = res.result.total;
          } else if (res.code == 401) {
            this.$refs["vipbox"].showLogin = true;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 新增从业人员
    addPersonnel() {
      this.$refs.AddPersonnelRef.dialogVisible = true;
      this.$refs.AddPersonnelRef.setData({});
    },
    rowDelete(row) {
      deleteDeclareAndDetailCyryApi({ declareId: row.id }).then((res) => {
        this.toSearchSh();
      });
    },
    reviewProgressClick(row) {
      this.ReviewProgressDetails.dialogVisible = true;
      this.ReviewProgressDetails.data.id = row.id;
    },
    handleClose() {
      this.ReviewProgressDetails.dialogVisible = false;
      this.toResetSh();
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .ivu-tabs-nav .ivu-tabs-tab {
  width: 200px;
  text-align: center;
  font-size: 18px;
}

.ryxx_box {
  margin: 10px 20px;
  // width: 100%;
  // max-width: 1000px;

  .search_box {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    font-size: 14px;
    margin: 20px 0;

    > div {
      display: flex;

      > div {
        margin: 10px;
        white-space: nowrap;
        cursor: pointer;
      }
    }

    .btn1 {
      background: linear-gradient(270deg, #2d85e2 2%, #5b43df 100%);
      color: #fff;
      padding: 5px 15px;
    }

    .btn2 {
      background: #767676;
      color: #fff;
      padding: 5px 15px;
    }

    .btn3 {
      background: red;
      color: #fff;
      padding: 5px 15px;
      float: right;
      margin-left: auto;
      margin-right: 10px;
    }

    .btn4 {
      background: #49b3ff;
      color: #fff;
      padding: 5px 15px;
      float: right;
      margin-left: auto;
      margin-right: 10px;
    }
  }

  .cell_box {
    margin-top: 20px;

    .cell {
      display: flex;
      width: 100%;
      white-space: nowrap;
      font-size: 15px;
      padding: 10px 0;
      text-align: center;
      border-left: 1px solid #eee;
      border-right: 1px solid #eee;

      > div:first-child {
        width: 8%;
      }

      > div:nth-child(2) {
        width: 10%;
      }

      > div:nth-child(3) {
        width: 10%;
      }

      > div:nth-child(4) {
        width: 15%;
      }

      > div:nth-child(5) {
        width: 25%;
      }

      > div:nth-child(6) {
        width: 15%;
      }

      > div:nth-child(7) {
        width: 10%;
      }

      > div:nth-child(8) {
        width: 10%;
      }

      > div:nth-child(9) {
        width: 10%;
      }
    }

    .th {
      background-color: #49b3ff;
    }

    .td {
      cursor: pointer;
    }

    .td:hover {
      background-color: #eee;
    }

    .td:nth-child(odd) {
      background-color: #d8d8d8;
    }

    .td:nth-child(even) {
      border-bottom: 1px solid #eee;
    }
  }
}

.model_box {
  /deep/ .ivu-modal-body {
    padding: 0;
  }

  /deep/ .ivu-modal-footer,
  /deep/ .ivu-modal-header {
    padding: 30px 50px;
    display: none;
  }
}
</style>
